<template>
  <div :class="$style.box" :style="{ paddingBottom: showBottomNav ? '50px' : '0' }">
    <!-- 新游推荐板块 -->
    <NewgameWrapperRecommend
      v-if="hasNewgameBannerList && newGameShow"
      ref="newGameBanner"
      :newgameBannerList="newgameBannerList"
      :isFirstEnter="isFirstEnter"
      @changeSlideType="changeSlideType"
      @closeNewgame="newGameShow = false"
    />
    <div
      :class="[
        slideType == 1 ? $style['box-slide-down'] : '',
        slideType == 2 ? $style['box-slide-up'] : '',
      ]"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import NewgameWrapperRecommend from './NewgameWrapperRecommend';

export default {
  components: {
    NewgameWrapperRecommend
  },
  props: {
    // 新游推荐位置：1:游戏圈首页；2:游戏中心页；3:游戏圈；4:个人主页
    location: {
      type: Number,
      default: 1
    },
    // 是否显示底部导航
    showBottomNav: {
      type: Boolean,
      default: false
    },
    // 是否首次加载
    isFirstEnter: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      newGameShow: false,
      slideType: '', // 1代表下拉，2代表上滑
    };
  },
  computed: {
    ...mapState('gameCircleCenter', {
      newgameBannerList: state => state.newgameBannerList,
      isFirstLogin: state => state.isFirstLogin
    }),
    // 新游推荐列表是否为空
    hasNewgameBannerList() {
      return this.newgameBannerList.length ? true : false
    }
  },
  mounted() {
    this.handleNewGameRecommend();
  },
  activated() {
    // 当不是首次进入页面，且不是从详情页返回的时候初始化并获取数据
    if (!this.$route.meta.isBack && !this.isFirstEnter) {
      this.newGameShow = false
      this.slideType = '' // 1代表下拉，2代表上滑
      this.handleNewGameRecommend();
    }
  },
  beforeDestroy() {
    this.CHANGE_STATE({
      newgameBannerList: [],
      topBannerList: []
    })
    this.newGameShow = false;
    this.slideType = '';
  },
  methods: {
    ...mapMutations('gameCircleCenter', {
      CHANGE_STATE: 'CHANGE_STATE'
    }),
    ...mapActions('gameCircleCenter', {
      getNewGameRecommendList: 'getNewGameRecommendList'
    }),
    // 获取新游推荐列表
    async handleNewGameRecommend() {
      await this.getNewGameRecommendList({ location: this.location, game_circle_id: this.$route.query.circleId });
      if (!this.newgameBannerList.length) return;
      // 2.用户首次登录 自动弹出弹窗
      if (this.isFirstLogin) {
        this.newGameShow = true;
        this.slideType = 1
      }
    },
    // 打开新游推荐页
    openNewGame() {
      if (!this.hasNewgameBannerList) return;
      this.newGameShow = true;
      this.slideType = 1;
    },
    changeSlideType(val) {
      this.slideType = val
    },
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/animation.scss';
.box-slide-up {
  @include newgame-home-slide-up;
}
.box-slide-down {
  @include newgame-home-slide-down;
}
.box {
  width: 100vw;
  min-height: 100vh;
  overflow-y: scroll;
}
</style>
